import { Injectable } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';

import { eNotificationTypes } from '../interfaces/constants';
import { NotificationComponent } from '../components/shared/notification/main';
import { NotificationService } from './notification.service';

@Injectable()
export class RanchWeatherUpdateService {

	private _notice: MatSnackBarRef<NotificationComponent>;

	constructor(private _notificationService: NotificationService) {
	}

	/**
	 * Shows "Updating ranch weather data..." with no duration. The save response dismisses it.
	 */
	public showUpdatingNotice(): void {
		if (this._notice) {
			return;
		}

		this._notice = this._notificationService.openUntimed({
			type: eNotificationTypes.UPDATE,
			message: 'Updating ranch weather data...',
			showSpinner: true
		});
	}

	/**
	 * Dismisses the "Updating ranch weather data..." notice.
	 */
	public dismissUpdatingNotice(): void {
		if (!this._notice) {
			return;
		}

		this._notice.dismiss();
		this._notice = null;
	}
}
